export const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const monthAbbrToFull = {
  JAN: "January",
  FEB: "February",
  MAR: "March",
  APR: "April",
  MAY: "May",
  JUN: "June",
  JUL: "July",
  AUG: "August",
  SEP: "September",
  OCT: "October",
  NOV: "November",
  DEC: "December",
};

export const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 10; i++) {
    years.push((currentYear + i).toString());
  }
  return years;
};

export const formatDate = (dateObj) => {
  return {
    formattedDate: `${dateObj.month} ${dateObj.day}, ${dateObj.year}`,
    formattedTime: `${dateObj.hour}:${dateObj.minute} ${dateObj.period}`,
  };
};

export const formatDateTime = (dateObj) => {
  const { month, day, year, hour, minute, period } = dateObj;
  const monthIndex =
    [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ].indexOf(month) + 1;
  return `${monthIndex
    .toString()
    .padStart(2, "0")}/${day}/${year} - ${hour}:${minute}${period}`;
};

const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return "th"; // for 4-20
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatFullDate = (dateObj) => {
  // Assuming dateObj.month is like 'APR', dateObj.day is a number, dateObj.year is a number
  const day = parseInt(dateObj.day, 10);
  if (isNaN(day)) {
    console.error("Invalid day for formatFullDate:", dateObj.day);
    return "Invalid Date";
  }
  const dayWithSuffix = day + getOrdinalSuffix(day);

  const upperMonth = dateObj.month?.toUpperCase(); // Add optional chaining and ensure month is a string
  if (!upperMonth) {
    console.error("Month is undefined or null for formatFullDate");
    return "Invalid Date";
  }
  const fullMonth = monthAbbrToFull[upperMonth];

  if (!fullMonth) {
    console.error(
      "Invalid month abbreviation for formatFullDate:",
      dateObj.month
    );
    return "Invalid Date"; // Or handle error as preferred
  }
  return `${dayWithSuffix} ${fullMonth} ${dateObj.year}`;
};

export const formatAPIDateToFullDate = (apiDateString) => {
  if (
    !apiDateString ||
    typeof apiDateString !== "string" ||
    apiDateString.toLowerCase() === "n/a"
  ) {
    return "N/A";
  }

  const parts = apiDateString.split("/");
  if (parts.length !== 3) {
    console.error("Invalid API date string format:", apiDateString);
    return apiDateString; // Return original string if format is wrong
  }

  const day = parts[0];
  const monthIndex = parseInt(parts[1], 10) - 1; // API month is 1-indexed
  const year = parts[2];

  if (isNaN(monthIndex) || monthIndex < 0 || monthIndex >= months.length) {
    console.error("Invalid month in API date string:", apiDateString);
    return apiDateString; // Return original string if month is invalid
  }

  const monthAbbr = months[monthIndex]; // Get "MAY" from 5

  return formatFullDate({ day, month: monthAbbr, year });
};

/** Short relative time for activity timelines (e.g. "2hrs", "3d"). */
export const getTimeAgo = (dateString) => {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffHours < 1) return "Just now";
  if (diffHours < 24) return `${diffHours}hr${diffHours > 1 ? "s" : ""}`;
  return `${diffDays}d`;
};
